// The share tag (14 Oct; moved here from api/src/core/sharing on 4 Nov 2026 so the web can test its shape): every
// player's own invite link carries `s-<CODE>-<first 8 hex of the player id>`. The API keeps the items and counts.
const SHARE_TAG = /^s-([A-HJ-NP-Z2-9]{5})-([0-9a-f]{8})$/;

/** The invite tag for a player of a battle. */
export function shareTag(code: string, playerId: string): string {
  return `s-${code.toUpperCase()}-${playerId.replace(/-/g, '').slice(0, 8).toLowerCase()}`;
}
/** The battle a share tag came from, when the tag is one. */
export function shareTagCode(tag: string | undefined): string | undefined {
  const m = typeof tag === 'string' ? SHARE_TAG.exec(tag) : null;
  return m ? m[1] : undefined;
}
